import { Footer } from 'components/_global/Footer/Footer';
import { Header } from 'components/_global/Header/Header';
import { Menu } from 'components/_global/Menu/Menu';
import { THEME_VARIANT } from 'shared/constants';
import { MainLayoutWrapper } from './MainLayout.styled';

interface IProps {
    children: any;
}

export const MainLayout: React.FC<IProps> = ({ children }) => {
    return (
        <MainLayoutWrapper>
            <Header />
            {THEME_VARIANT !== 'DOCTOR' && <Menu />}
            {children}
            {THEME_VARIANT === 'DOCTOR' && <Footer />}
        </MainLayoutWrapper>
    );
};
